module.exports = __webpack_public_path__ + "static/media/John Sierega Headshot_1591105912204.0bec3ddc.jpg";